// extracted by mini-css-extract-plugin
export var container = "TakeATour-module--container--151d6";
export var desktop = "TakeATour-module--desktop--61af2";
export var hidden = "TakeATour-module--hidden--138a8";
export var link = "TakeATour-module--link--f53b1";
export var mobile = "TakeATour-module--mobile--becde";